import ContentBox from "../../../ContentBox/ContentBox";
import { Typography } from "@mui/material";
import ButtonLoading from "../../../Button/ButtonLoading";
import { useState } from "react";
import { useSnackbar } from "notistack";
import ApiClient from "../../../../services/ApiClient";
import { apiGet } from "../../../../services/Api/apiCall.ts";

export default function EmailProcessing() {
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const startWatchBcc = async () => {
    setIsLoading(true);
    try {
      await ApiClient.get("/start_watch_bcc");
      enqueueSnackbar("Mailverarbeitung wurde neu gestartet", {
        variant: "custom",
        isNonInteractive: true,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
      });
    } catch (e) {
      enqueueSnackbar("Mailverarbeitung konnte nicht neu gestartet werden", {
        variant: "error",
        isNonInteractive: true,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
      });
    }
    setIsLoading(false);
  };

  return (
    <ContentBox headline="Mailverarbeitung neu starten">
      <Typography
        sx={{
          margin: "1rem 0",
        }}
      >
        Falls es bei der Mailverarbeitung zu Fehlern kommt, kann diese durch einen Klick auf “Mailverarbeitung neu
        starten” neu angestoßen werden.
      </Typography>
      <ButtonLoading variant={"contained"} onClick={startWatchBcc} isLoading={isLoading}>
        Mailverarbeitung neu starten
      </ButtonLoading>
      <ButtonLoading
        sx={{ marginTop: "1rem" }}
        variant={"contained"}
        onClick={async () => {
          setIsLoading(true);
          await apiGet("/sync_bcc_inbox");
          setIsLoading(false);
        }}
        isLoading={isLoading}
      >
        inbox manuell importieren
      </ButtonLoading>
      <Typography>feature existiert nur auf testing branch. auf keinen fall spammen, je nach mailvolumen dauert der sync einfach 30 minuten</Typography>
    </ContentBox>
  );
}
